import { render, staticRenderFns } from "./review-item.vue?vue&type=template&id=bb9b41aa&scoped=true&"
import script from "./review-item.vue?vue&type=script&lang=js&"
export * from "./review-item.vue?vue&type=script&lang=js&"
import style0 from "./review-item.vue?vue&type=style&index=0&id=bb9b41aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b41aa",
  null
  
)

export default component.exports